// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* SignInForm Component Styles - Sticky bottom with Phone & OTP flow */

/* Backdrop overlay with blur effect */
.signInForm_backdrop__ERAR6 {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 99;
  background: rgba(0, 0, 0, 0.5);
  backdrop-filter: blur(4px);
  -webkit-backdrop-filter: blur(4px);
  transition: opacity 0.4s cubic-bezier(0.4, 0, 0.2, 1),
              backdrop-filter 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  /* Prevent scrolling on backdrop */
  touch-action: none;
  overscroll-behavior: contain;
}

.signInForm_backdropVisible__tSQT3 {
  opacity: 1;
  pointer-events: auto;
}

.signInForm_backdropHidden__wurSW {
  opacity: 0;
  pointer-events: none;
  backdrop-filter: blur(0px);
  -webkit-backdrop-filter: blur(0px);
}

.signInForm_stickyContainer__\\+uss4 {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 100;
  width: 100%;
  max-width: 100%;
  /* Prevent the form from scrolling with page */
  overscroll-behavior: contain;
  /* Entrance animation - slide up from bottom with fade */
  animation: signInForm_slideUpEntrance__Av-XK 1.4s cubic-bezier(0.4, 0, 0.2, 1) forwards;
}

@keyframes signInForm_slideUpEntrance__Av-XK {
  from {
    opacity: 0.9;
    transform: translateY(30%);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.signInForm_signInFormContainer__1OFQe {
  max-width: 500px;
  margin: 0 auto;
  width: 100%;
  position: relative;
  border-radius: 32px 32px 0 0;
  padding: 32px 24px 40px;
  overflow: hidden;
background: linear-gradient(180deg, #7A1143 0%, #0D0E11 51.25%);
  /* Background image for gradient effect */
  background-image: url('https://static-perf1.zupee.com/blog-images/uploads/2025/12/bgeffect-001.webp');
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  border-top: 1px solid #F9A870;
}

/* Gradient Background SVG - kept as fallback */
.signInForm_gradientBackgroundSvg__C9-ye {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 0;
  pointer-events: none;
  display: none; /* Hidden since we're using background image */
}

/* Content wrapper to stay above gradient */
.signInForm_contentWrapper__4CNq\\+ {
  position: relative;
  z-index: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 24px;
}

/* ========== PHONE INPUT VIEW ========== */

/* Title Section */
.signInForm_titleSection__yuOoJ {
  text-align: center;
  margin-bottom: 8px;
}

.signInForm_title__6q5T0 {
  font-size: 28px;
  font-weight: 700;
  color: #F3F4F6;
  margin: 0 0 8px 0;
  line-height: 1.2;
  font-family: "Noto Sans";
  /* Zoom in/out animation */
  animation: signInForm_zoomInOut__MfDOa 2s ease-in-out infinite;
  transform-origin: center;
}

@keyframes signInForm_zoomInOut__MfDOa {
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.08);
  }
  100% {
    transform: scale(1);
  }
}

.signInForm_subtitle__WLAnD {
  font-size: 16px;
  font-weight: 400;
  color: #F3F4F6;
  margin: 0;
}

/* Phone Input Section */
.signInForm_phoneInputWrapper__PWtIM {
  width: 100%;
  /* max-width: 312px; */
  display: flex;
  align-items: center;
  background: #FFFFFF;
  border-radius: 12px;
  overflow: visible; /* Changed from hidden to prevent button clipping */
  height: 56px;
  padding-left: 6px;
  padding-right: 6px;
  gap: 4px; /* Add consistent gap between elements */
  box-sizing: border-box;
}

.signInForm_countryCode__M2uqM {
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 8px 10px; /* Increased horizontal padding */
  height: 42px;
  background-color: #E5E7EB;
  flex-shrink: 0;
  flex-grow: 0;
  border-radius: 8px;
  min-width: fit-content; /* Prevent shrinking below content */
  box-sizing: border-box;
}

.signInForm_flagIcon__UBus\\+ {
  width: 24px;
  height: 18px;
  min-width: 24px; /* Prevent shrinking */
  min-height: 18px; /* Prevent shrinking */
  border-radius: 2px;
  object-fit: cover;
  flex-shrink: 0;
}

.signInForm_countryCodeText__WP7zL {
  font-size: 16px;
  font-weight: 500;
  color: #1F2937;
  white-space: nowrap; /* Prevent text wrapping */
  flex-shrink: 0;
}

.signInForm_phoneInput__9mg1d {
  flex: 1 1;
  min-width: 0; /* Critical fix: allows flex item to shrink below content size */
  border: none;
  outline: none;
  font-size: 16px;
  font-weight: 400;
  color: #1F2937;
  padding: 0 8px;
  height: 100%;
  background: transparent;
  box-sizing: border-box;
}

.signInForm_phoneInput__9mg1d::placeholder {
  color: #9CA3AF;
}

/* Submit Button (Arrow) */
.signInForm_submitButton__Y0Y3\\+ {
  width: 42px;
  height: 42px;
  min-width: 42px; /* Prevent shrinking */
  min-height: 42px; /* Prevent shrinking */
  border-radius: 8px;
  background: #E5E7EB;
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.2s ease;
  flex-shrink: 0;
  flex-grow: 0;
  box-sizing: border-box;
}

.signInForm_submitButton__Y0Y3\\+:disabled {
  background: #E5E7EB;
  cursor: not-allowed;
}

.signInForm_submitButton__Y0Y3\\+:not(:disabled) {
  background: #000000;
}

.signInForm_submitButton__Y0Y3\\+:not(:disabled):hover {
  transform: scale(1.05);
}

.signInForm_arrowIcon__HN8-w {
  width: 24px;
  height: 24px;
  opacity: 0.5;
  transition: opacity 0.2s ease;
}

.signInForm_submitButton__Y0Y3\\+:not(:disabled) .signInForm_arrowIcon__HN8-w {
  opacity: 1;
}

/* Terms Section */
.signInForm_termsSection__6MhJd {
  text-align: center;
  max-width: 280px;
  overflow: hidden;
  /* Smooth transition for both show and hide */
  transition: opacity 0.4s cubic-bezier(0.4, 0, 0.2, 1),
              transform 0.4s cubic-bezier(0.4, 0, 0.2, 1),
              max-height 0.4s cubic-bezier(0.4, 0, 0.2, 1);
}

/* Terms visible state */
.signInForm_termsVisible__EjCH0 {
  opacity: 1;
  transform: translateY(0);
  max-height: 100px;
  pointer-events: auto;
}

/* Terms hidden state */
.signInForm_termsHidden__drNVq {
  opacity: 0;
  transform: translateY(15px);
  max-height: 0;
  pointer-events: none;
}

.signInForm_termsText__SnfAy {
  font-size: 12px;
  font-weight: 400;
  color: #9396A3;
  line-height: 1.5;
}

.signInForm_termsLink__RM\\+3w {
  color: #F3F4F6;
  font-weight: 600;
  text-decoration: underline;
  cursor: pointer;
}

.signInForm_termsLink__RM\\+3w:hover {
  color: #FFFFFF;
}

/* ========== OTP VIEW ========== */

.signInForm_otpHeader__OkDcm {
  display: flex;
  align-items: center;
  width: 100%;
  position: relative;
  justify-content: center;
  padding: 0 16px;
}

.signInForm_backButton__TQe0- {
  position: absolute;
  left: 0px;
  background: none;
  border: none;
  padding: 8px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10;
}

.signInForm_backButton__TQe0-:active {
  opacity: 0.7;
}

.signInForm_backIcon__doRBA {
  width: 24px;
  height: 24px;
}

.signInForm_backIcon__doRBA path {
  stroke: #F3F4F6;
}

.signInForm_otpTitle__8v76j {
  font-size: 24px;
  font-weight: 700;
  color: #F3F4F6;
  margin: 0;
  text-align: center;
  font-family: "Noto Sans";
}

/* OTP Input Container */
.signInForm_otpInputContainer__4BhXh {
  display: flex;
  gap: 5px;
  justify-content: center;
  width: 100%;
  padding: 0 16px;
}

.signInForm_otpInputWrapper__b0cKz {
  position: relative;
  width: 48px;
  height: 48px;
}

/* Circular OTP Input - matches design screenshot */
.signInForm_otpInput__4ZWeR {
  width: 46px;
  height: 46px;
  border: 1.5px solid rgba(255, 255, 255, 0.3);
  border-radius: 50%;
  background: transparent;
  font-size: 18px;
  font-weight: 600;
  color: #F3F4F6;
  text-align: center;
  outline: none;
  transition: all 0.2s ease;
  appearance: textfield;
}

.signInForm_otpInput__4ZWeR::-webkit-outer-spin-button,
.signInForm_otpInput__4ZWeR::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

.signInForm_otpInput__4ZWeR:focus {
  border-color: rgba(255, 255, 255, 0.6);
}

.signInForm_otpInput__4ZWeR.signInForm_active__Wmqaz {
  border-color: rgba(255, 255, 255, 0.6);
}

.signInForm_otpInput__4ZWeR.signInForm_filled__mz2kB {
  border-color: rgba(255, 255, 255, 0.5);
  background: transparent;
}

/* Small dot cursor for empty OTP input - matches design */
.signInForm_otpCursor__Nn-Eb {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 6px;
  height: 6px;
  background: rgba(255, 255, 255, 0.6);
  border-radius: 50%;
  pointer-events: none;
}

@keyframes signInForm_blink__a\\+Pgt {
  0%, 50% { opacity: 1; }
  51%, 100% { opacity: 0; }
}

.signInForm_hideCaret__BxpeB {
  caret-color: transparent;
}

/* OTP Info Section */
.signInForm_otpInfoSection__6GwI9 {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  color: #9396A3;
  font-size: 14px;
}

.signInForm_phoneNumberDisplay__\\+u3HV {
  color: #F3F4F6;
  font-weight: 500;
}

.signInForm_separator__ZNQMY {
  color: #6B7280;
}

.signInForm_resendText__zOWfg {
  color: #9396A3;
}

.signInForm_resendButton__mue-f {
  background: none;
  border: none;
  color: #8B5CF6;
  font-weight: 600;
  cursor: pointer;
  padding: 0;
  font-size: 14px;
}

.signInForm_resendButton__mue-f:disabled {
  color: #6B7280;
  cursor: not-allowed;
}

/* Verify Button */
.signInForm_verifyButton__O5m2P {
  width: 100%;
  max-width: 312px;
  height: 56px;
  border-radius: 16px;
  border: none;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  background: #353945;
  color: #6A718B;
}

.signInForm_verifyButton__O5m2P:not(:disabled) {
  background: #FFFFFF;
  color: #000000;
}

.signInForm_verifyButton__O5m2P:not(:disabled):hover {
  transform: scale(1.02);
}

/* Loading State */
.signInForm_loadingSpinner__3TJd- {
  width: 24px;
  height: 24px;
  border: 2px solid #9CA3AF;
  border-top-color: transparent;
  border-radius: 50%;
  animation: signInForm_spin__uViWu 0.8s linear infinite;
}

@keyframes signInForm_spin__uViWu {
  to {
    transform: rotate(360deg);
  }
}

/* View Transition */
.signInForm_fadeIn__BMWDP {
  animation: signInForm_fadeIn__BMWDP 0.3s ease-out;
}

@keyframes signInForm_fadeIn__BMWDP {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* fadeInTerms - kept for backwards compatibility, transitions now use termsVisible/termsHidden */
.signInForm_fadeInTerms__cC5kf {
  opacity: 1;
}

/* ========== RESPONSIVE STYLES FOR PORTRAIT MODE ========== */

/* Small screens in portrait mode (Galaxy S24, Narzo, etc.) */
@media screen and (max-width: 400px) {
  .signInForm_phoneInputWrapper__PWtIM {
    padding-left: 4px;
    padding-right: 4px;
    gap: 3px;
  }
  
  .signInForm_countryCode__M2uqM {
    padding: 6px 8px;
    gap: 3px;
    height: 40px;
  }
  
  .signInForm_flagIcon__UBus\\+ {
    width: 22px;
    height: 16px;
    min-width: 22px;
    min-height: 16px;
  }
  
  .signInForm_countryCodeText__WP7zL {
    font-size: 15px;
  }
  
  .signInForm_phoneInput__9mg1d {
    padding: 0 6px;
    font-size: 15px;
  }
  
  .signInForm_submitButton__Y0Y3\\+ {
    width: 40px;
    height: 40px;
    min-width: 40px;
    min-height: 40px;
  }
  
  .signInForm_arrowIcon__HN8-w {
    width: 22px;
    height: 22px;
  }
}

/* Very small screens (under 360px width) */
@media screen and (max-width: 360px) {
  .signInForm_signInFormContainer__1OFQe {
    padding: 24px 16px 32px;
  }
  
  .signInForm_phoneInputWrapper__PWtIM {
    height: 52px;
    padding-left: 3px;
    padding-right: 3px;
    gap: 2px;
  }
  
  .signInForm_countryCode__M2uqM {
    padding: 5px 6px;
    gap: 2px;
    height: 38px;
  }
  
  .signInForm_flagIcon__UBus\\+ {
    width: 20px;
    height: 14px;
    min-width: 20px;
    min-height: 14px;
  }
  
  .signInForm_countryCodeText__WP7zL {
    font-size: 14px;
  }
  
  .signInForm_phoneInput__9mg1d {
    padding: 0 4px;
    font-size: 14px;
  }
  
  .signInForm_submitButton__Y0Y3\\+ {
    width: 38px;
    height: 38px;
    min-width: 38px;
    min-height: 38px;
  }
  
  .signInForm_arrowIcon__HN8-w {
    width: 20px;
    height: 20px;
  }
  
  .signInForm_title__6q5T0 {
    font-size: 24px;
  }
  
  .signInForm_subtitle__WLAnD {
    font-size: 14px;
  }
}

/* Portrait orientation specific handling */
@media screen and (orientation: portrait) and (max-width: 450px) {
  .signInForm_phoneInputWrapper__PWtIM {
    /* Ensure all children stay visible */
    overflow: visible;
  }
  
  .signInForm_countryCode__M2uqM,
  .signInForm_submitButton__Y0Y3\\+ {
    /* Ensure these never shrink */
    flex-shrink: 0;
    flex-basis: auto;
  }
  
  .signInForm_phoneInput__9mg1d {
    /* Allow input to shrink but not disappear */
    min-width: 80px;
    flex: 1 1 auto;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/pwatv/SignInForm/signInForm.module.css"],"names":[],"mappings":"AAAA,sEAAsE;;AAEtE,sCAAsC;AACtC;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,WAAW;EACX,8BAA8B;EAC9B,0BAA0B;EAC1B,kCAAkC;EAClC;+DAC6D;EAC7D,kCAAkC;EAClC,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA;EACE,UAAU;EACV,oBAAoB;AACtB;;AAEA;EACE,UAAU;EACV,oBAAoB;EACpB,0BAA0B;EAC1B,kCAAkC;AACpC;;AAEA;EACE,eAAe;EACf,SAAS;EACT,OAAO;EACP,QAAQ;EACR,YAAY;EACZ,WAAW;EACX,eAAe;EACf,8CAA8C;EAC9C,4BAA4B;EAC5B,wDAAwD;EACxD,uFAAqE;AACvE;;AAEA;EACE;IACE,YAAY;IACZ,0BAA0B;EAC5B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,WAAW;EACX,kBAAkB;EAClB,4BAA4B;EAC5B,uBAAuB;EACvB,gBAAgB;AAClB,+DAA+D;EAC7D,yCAAyC;EACzC,qGAAqG;EACrG,sBAAsB;EACtB,2BAA2B;EAC3B,4BAA4B;EAC5B,6BAA6B;AAC/B;;AAEA,+CAA+C;AAC/C;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,UAAU;EACV,oBAAoB;EACpB,aAAa,EAAE,8CAA8C;AAC/D;;AAEA,2CAA2C;AAC3C;EACE,kBAAkB;EAClB,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;AACX;;AAEA,2CAA2C;;AAE3C,kBAAkB;AAClB;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,wBAAwB;EACxB,0BAA0B;EAC1B,8DAA4C;EAC5C,wBAAwB;AAC1B;;AAEA;EACE;IACE,mBAAmB;EACrB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,SAAS;AACX;;AAEA,wBAAwB;AACxB;EACE,WAAW;EACX,sBAAsB;EACtB,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,iBAAiB,EAAE,mDAAmD;EACtE,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,QAAQ,EAAE,wCAAwC;EAClD,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB,EAAE,iCAAiC;EACpD,YAAY;EACZ,yBAAyB;EACzB,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,sBAAsB,EAAE,oCAAoC;EAC5D,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe,EAAE,sBAAsB;EACvC,gBAAgB,EAAE,sBAAsB;EACxC,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB,EAAE,0BAA0B;EAC/C,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,YAAY,EAAE,gEAAgE;EAC9E,YAAY;EACZ,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,cAAc;EACd,YAAY;EACZ,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE,cAAc;AAChB;;AAEA,0BAA0B;AAC1B;EACE,WAAW;EACX,YAAY;EACZ,eAAe,EAAE,sBAAsB;EACvC,gBAAgB,EAAE,sBAAsB;EACxC,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,yBAAyB;EACzB,cAAc;EACd,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,6BAA6B;AAC/B;;AAEA;EACE,UAAU;AACZ;;AAEA,kBAAkB;AAClB;EACE,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,6CAA6C;EAC7C;;0DAEwD;AAC1D;;AAEA,wBAAwB;AACxB;EACE,UAAU;EACV,wBAAwB;EACxB,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA,uBAAuB;AACvB;EACE,UAAU;EACV,2BAA2B;EAC3B,aAAa;EACb,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,0BAA0B;EAC1B,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA,mCAAmC;;AAEnC;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,kBAAkB;EAClB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,gBAAgB;EAChB,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,SAAS;EACT,kBAAkB;EAClB,wBAAwB;AAC1B;;AAEA,wBAAwB;AACxB;EACE,aAAa;EACb,QAAQ;EACR,uBAAuB;EACvB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;;AAEA,mDAAmD;AACnD;EACE,WAAW;EACX,YAAY;EACZ,4CAA4C;EAC5C,kBAAkB;EAClB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,aAAa;EACb,yBAAyB;EAEzB,qBAAqB;AACvB;;AAEA;;EAEE,wBAAwB;EACxB,SAAS;AACX;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,sCAAsC;EACtC,uBAAuB;AACzB;;AAEA,0DAA0D;AAC1D;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,UAAU;EACV,WAAW;EACX,oCAAoC;EACpC,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,UAAU,UAAU,EAAE;EACtB,YAAY,UAAU,EAAE;AAC1B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,UAAU;EACV,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA,kBAAkB;AAClB;EACE,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,sBAAsB;AACxB;;AAEA,kBAAkB;AAClB;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,6BAA6B;EAC7B,kBAAkB;EAClB,sDAAoC;AACtC;;AAEA;EACE;IACE,yBAAyB;EAC3B;AACF;;AAEA,oBAAoB;AACpB;EACE,iDAA+B;AACjC;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA,iGAAiG;AACjG;EACE,UAAU;AACZ;;AAEA,8DAA8D;;AAE9D,6DAA6D;AAC7D;EACE;IACE,iBAAiB;IACjB,kBAAkB;IAClB,QAAQ;EACV;;EAEA;IACE,gBAAgB;IAChB,QAAQ;IACR,YAAY;EACd;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,cAAc;IACd,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;AACF;;AAEA,2CAA2C;AAC3C;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,QAAQ;EACV;;EAEA;IACE,gBAAgB;IAChB,QAAQ;IACR,YAAY;EACd;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,cAAc;IACd,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA,2CAA2C;AAC3C;EACE;IACE,qCAAqC;IACrC,iBAAiB;EACnB;;EAEA;;IAEE,8BAA8B;IAC9B,cAAc;IACd,gBAAgB;EAClB;;EAEA;IACE,4CAA4C;IAC5C,eAAe;IACf,cAAc;EAChB;AACF","sourcesContent":["/* SignInForm Component Styles - Sticky bottom with Phone & OTP flow */\n\n/* Backdrop overlay with blur effect */\n.backdrop {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  z-index: 99;\n  background: rgba(0, 0, 0, 0.5);\n  backdrop-filter: blur(4px);\n  -webkit-backdrop-filter: blur(4px);\n  transition: opacity 0.4s cubic-bezier(0.4, 0, 0.2, 1),\n              backdrop-filter 0.4s cubic-bezier(0.4, 0, 0.2, 1);\n  /* Prevent scrolling on backdrop */\n  touch-action: none;\n  overscroll-behavior: contain;\n}\n\n.backdropVisible {\n  opacity: 1;\n  pointer-events: auto;\n}\n\n.backdropHidden {\n  opacity: 0;\n  pointer-events: none;\n  backdrop-filter: blur(0px);\n  -webkit-backdrop-filter: blur(0px);\n}\n\n.stickyContainer {\n  position: fixed;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  z-index: 100;\n  width: 100%;\n  max-width: 100%;\n  /* Prevent the form from scrolling with page */\n  overscroll-behavior: contain;\n  /* Entrance animation - slide up from bottom with fade */\n  animation: slideUpEntrance 1.4s cubic-bezier(0.4, 0, 0.2, 1) forwards;\n}\n\n@keyframes slideUpEntrance {\n  from {\n    opacity: 0.9;\n    transform: translateY(30%);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.signInFormContainer {\n  max-width: 500px;\n  margin: 0 auto;\n  width: 100%;\n  position: relative;\n  border-radius: 32px 32px 0 0;\n  padding: 32px 24px 40px;\n  overflow: hidden;\nbackground: linear-gradient(180deg, #7A1143 0%, #0D0E11 51.25%);\n  /* Background image for gradient effect */\n  background-image: url('https://static-perf1.zupee.com/blog-images/uploads/2025/12/bgeffect-001.webp');\n  background-size: cover;\n  background-position: center;\n  background-repeat: no-repeat;\n  border-top: 1px solid #F9A870;\n}\n\n/* Gradient Background SVG - kept as fallback */\n.gradientBackgroundSvg {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  z-index: 0;\n  pointer-events: none;\n  display: none; /* Hidden since we're using background image */\n}\n\n/* Content wrapper to stay above gradient */\n.contentWrapper {\n  position: relative;\n  z-index: 1;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 24px;\n}\n\n/* ========== PHONE INPUT VIEW ========== */\n\n/* Title Section */\n.titleSection {\n  text-align: center;\n  margin-bottom: 8px;\n}\n\n.title {\n  font-size: 28px;\n  font-weight: 700;\n  color: #F3F4F6;\n  margin: 0 0 8px 0;\n  line-height: 1.2;\n  font-family: \"Noto Sans\";\n  /* Zoom in/out animation */\n  animation: zoomInOut 2s ease-in-out infinite;\n  transform-origin: center;\n}\n\n@keyframes zoomInOut {\n  0% {\n    transform: scale(1);\n  }\n  50% {\n    transform: scale(1.08);\n  }\n  100% {\n    transform: scale(1);\n  }\n}\n\n.subtitle {\n  font-size: 16px;\n  font-weight: 400;\n  color: #F3F4F6;\n  margin: 0;\n}\n\n/* Phone Input Section */\n.phoneInputWrapper {\n  width: 100%;\n  /* max-width: 312px; */\n  display: flex;\n  align-items: center;\n  background: #FFFFFF;\n  border-radius: 12px;\n  overflow: visible; /* Changed from hidden to prevent button clipping */\n  height: 56px;\n  padding-left: 6px;\n  padding-right: 6px;\n  gap: 4px; /* Add consistent gap between elements */\n  box-sizing: border-box;\n}\n\n.countryCode {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  padding: 8px 10px; /* Increased horizontal padding */\n  height: 42px;\n  background-color: #E5E7EB;\n  flex-shrink: 0;\n  flex-grow: 0;\n  border-radius: 8px;\n  min-width: fit-content; /* Prevent shrinking below content */\n  box-sizing: border-box;\n}\n\n.flagIcon {\n  width: 24px;\n  height: 18px;\n  min-width: 24px; /* Prevent shrinking */\n  min-height: 18px; /* Prevent shrinking */\n  border-radius: 2px;\n  object-fit: cover;\n  flex-shrink: 0;\n}\n\n.countryCodeText {\n  font-size: 16px;\n  font-weight: 500;\n  color: #1F2937;\n  white-space: nowrap; /* Prevent text wrapping */\n  flex-shrink: 0;\n}\n\n.phoneInput {\n  flex: 1;\n  min-width: 0; /* Critical fix: allows flex item to shrink below content size */\n  border: none;\n  outline: none;\n  font-size: 16px;\n  font-weight: 400;\n  color: #1F2937;\n  padding: 0 8px;\n  height: 100%;\n  background: transparent;\n  box-sizing: border-box;\n}\n\n.phoneInput::placeholder {\n  color: #9CA3AF;\n}\n\n/* Submit Button (Arrow) */\n.submitButton {\n  width: 42px;\n  height: 42px;\n  min-width: 42px; /* Prevent shrinking */\n  min-height: 42px; /* Prevent shrinking */\n  border-radius: 8px;\n  background: #E5E7EB;\n  border: none;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  flex-shrink: 0;\n  flex-grow: 0;\n  box-sizing: border-box;\n}\n\n.submitButton:disabled {\n  background: #E5E7EB;\n  cursor: not-allowed;\n}\n\n.submitButton:not(:disabled) {\n  background: #000000;\n}\n\n.submitButton:not(:disabled):hover {\n  transform: scale(1.05);\n}\n\n.arrowIcon {\n  width: 24px;\n  height: 24px;\n  opacity: 0.5;\n  transition: opacity 0.2s ease;\n}\n\n.submitButton:not(:disabled) .arrowIcon {\n  opacity: 1;\n}\n\n/* Terms Section */\n.termsSection {\n  text-align: center;\n  max-width: 280px;\n  overflow: hidden;\n  /* Smooth transition for both show and hide */\n  transition: opacity 0.4s cubic-bezier(0.4, 0, 0.2, 1),\n              transform 0.4s cubic-bezier(0.4, 0, 0.2, 1),\n              max-height 0.4s cubic-bezier(0.4, 0, 0.2, 1);\n}\n\n/* Terms visible state */\n.termsVisible {\n  opacity: 1;\n  transform: translateY(0);\n  max-height: 100px;\n  pointer-events: auto;\n}\n\n/* Terms hidden state */\n.termsHidden {\n  opacity: 0;\n  transform: translateY(15px);\n  max-height: 0;\n  pointer-events: none;\n}\n\n.termsText {\n  font-size: 12px;\n  font-weight: 400;\n  color: #9396A3;\n  line-height: 1.5;\n}\n\n.termsLink {\n  color: #F3F4F6;\n  font-weight: 600;\n  text-decoration: underline;\n  cursor: pointer;\n}\n\n.termsLink:hover {\n  color: #FFFFFF;\n}\n\n/* ========== OTP VIEW ========== */\n\n.otpHeader {\n  display: flex;\n  align-items: center;\n  width: 100%;\n  position: relative;\n  justify-content: center;\n  padding: 0 16px;\n}\n\n.backButton {\n  position: absolute;\n  left: 0px;\n  background: none;\n  border: none;\n  padding: 8px;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 10;\n}\n\n.backButton:active {\n  opacity: 0.7;\n}\n\n.backIcon {\n  width: 24px;\n  height: 24px;\n}\n\n.backIcon path {\n  stroke: #F3F4F6;\n}\n\n.otpTitle {\n  font-size: 24px;\n  font-weight: 700;\n  color: #F3F4F6;\n  margin: 0;\n  text-align: center;\n  font-family: \"Noto Sans\";\n}\n\n/* OTP Input Container */\n.otpInputContainer {\n  display: flex;\n  gap: 5px;\n  justify-content: center;\n  width: 100%;\n  padding: 0 16px;\n}\n\n.otpInputWrapper {\n  position: relative;\n  width: 48px;\n  height: 48px;\n}\n\n/* Circular OTP Input - matches design screenshot */\n.otpInput {\n  width: 46px;\n  height: 46px;\n  border: 1.5px solid rgba(255, 255, 255, 0.3);\n  border-radius: 50%;\n  background: transparent;\n  font-size: 18px;\n  font-weight: 600;\n  color: #F3F4F6;\n  text-align: center;\n  outline: none;\n  transition: all 0.2s ease;\n  -moz-appearance: textfield;\n  appearance: textfield;\n}\n\n.otpInput::-webkit-outer-spin-button,\n.otpInput::-webkit-inner-spin-button {\n  -webkit-appearance: none;\n  margin: 0;\n}\n\n.otpInput:focus {\n  border-color: rgba(255, 255, 255, 0.6);\n}\n\n.otpInput.active {\n  border-color: rgba(255, 255, 255, 0.6);\n}\n\n.otpInput.filled {\n  border-color: rgba(255, 255, 255, 0.5);\n  background: transparent;\n}\n\n/* Small dot cursor for empty OTP input - matches design */\n.otpCursor {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  width: 6px;\n  height: 6px;\n  background: rgba(255, 255, 255, 0.6);\n  border-radius: 50%;\n  pointer-events: none;\n}\n\n@keyframes blink {\n  0%, 50% { opacity: 1; }\n  51%, 100% { opacity: 0; }\n}\n\n.hideCaret {\n  caret-color: transparent;\n}\n\n/* OTP Info Section */\n.otpInfoSection {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  color: #9396A3;\n  font-size: 14px;\n}\n\n.phoneNumberDisplay {\n  color: #F3F4F6;\n  font-weight: 500;\n}\n\n.separator {\n  color: #6B7280;\n}\n\n.resendText {\n  color: #9396A3;\n}\n\n.resendButton {\n  background: none;\n  border: none;\n  color: #8B5CF6;\n  font-weight: 600;\n  cursor: pointer;\n  padding: 0;\n  font-size: 14px;\n}\n\n.resendButton:disabled {\n  color: #6B7280;\n  cursor: not-allowed;\n}\n\n/* Verify Button */\n.verifyButton {\n  width: 100%;\n  max-width: 312px;\n  height: 56px;\n  border-radius: 16px;\n  border: none;\n  font-size: 16px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  background: #353945;\n  color: #6A718B;\n}\n\n.verifyButton:not(:disabled) {\n  background: #FFFFFF;\n  color: #000000;\n}\n\n.verifyButton:not(:disabled):hover {\n  transform: scale(1.02);\n}\n\n/* Loading State */\n.loadingSpinner {\n  width: 24px;\n  height: 24px;\n  border: 2px solid #9CA3AF;\n  border-top-color: transparent;\n  border-radius: 50%;\n  animation: spin 0.8s linear infinite;\n}\n\n@keyframes spin {\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n/* View Transition */\n.fadeIn {\n  animation: fadeIn 0.3s ease-out;\n}\n\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n    transform: translateY(10px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n/* fadeInTerms - kept for backwards compatibility, transitions now use termsVisible/termsHidden */\n.fadeInTerms {\n  opacity: 1;\n}\n\n/* ========== RESPONSIVE STYLES FOR PORTRAIT MODE ========== */\n\n/* Small screens in portrait mode (Galaxy S24, Narzo, etc.) */\n@media screen and (max-width: 400px) {\n  .phoneInputWrapper {\n    padding-left: 4px;\n    padding-right: 4px;\n    gap: 3px;\n  }\n  \n  .countryCode {\n    padding: 6px 8px;\n    gap: 3px;\n    height: 40px;\n  }\n  \n  .flagIcon {\n    width: 22px;\n    height: 16px;\n    min-width: 22px;\n    min-height: 16px;\n  }\n  \n  .countryCodeText {\n    font-size: 15px;\n  }\n  \n  .phoneInput {\n    padding: 0 6px;\n    font-size: 15px;\n  }\n  \n  .submitButton {\n    width: 40px;\n    height: 40px;\n    min-width: 40px;\n    min-height: 40px;\n  }\n  \n  .arrowIcon {\n    width: 22px;\n    height: 22px;\n  }\n}\n\n/* Very small screens (under 360px width) */\n@media screen and (max-width: 360px) {\n  .signInFormContainer {\n    padding: 24px 16px 32px;\n  }\n  \n  .phoneInputWrapper {\n    height: 52px;\n    padding-left: 3px;\n    padding-right: 3px;\n    gap: 2px;\n  }\n  \n  .countryCode {\n    padding: 5px 6px;\n    gap: 2px;\n    height: 38px;\n  }\n  \n  .flagIcon {\n    width: 20px;\n    height: 14px;\n    min-width: 20px;\n    min-height: 14px;\n  }\n  \n  .countryCodeText {\n    font-size: 14px;\n  }\n  \n  .phoneInput {\n    padding: 0 4px;\n    font-size: 14px;\n  }\n  \n  .submitButton {\n    width: 38px;\n    height: 38px;\n    min-width: 38px;\n    min-height: 38px;\n  }\n  \n  .arrowIcon {\n    width: 20px;\n    height: 20px;\n  }\n  \n  .title {\n    font-size: 24px;\n  }\n  \n  .subtitle {\n    font-size: 14px;\n  }\n}\n\n/* Portrait orientation specific handling */\n@media screen and (orientation: portrait) and (max-width: 450px) {\n  .phoneInputWrapper {\n    /* Ensure all children stay visible */\n    overflow: visible;\n  }\n  \n  .countryCode,\n  .submitButton {\n    /* Ensure these never shrink */\n    flex-shrink: 0;\n    flex-basis: auto;\n  }\n  \n  .phoneInput {\n    /* Allow input to shrink but not disappear */\n    min-width: 80px;\n    flex: 1 1 auto;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"backdrop": `signInForm_backdrop__ERAR6`,
	"backdropVisible": `signInForm_backdropVisible__tSQT3`,
	"backdropHidden": `signInForm_backdropHidden__wurSW`,
	"stickyContainer": `signInForm_stickyContainer__+uss4`,
	"slideUpEntrance": `signInForm_slideUpEntrance__Av-XK`,
	"signInFormContainer": `signInForm_signInFormContainer__1OFQe`,
	"gradientBackgroundSvg": `signInForm_gradientBackgroundSvg__C9-ye`,
	"contentWrapper": `signInForm_contentWrapper__4CNq+`,
	"titleSection": `signInForm_titleSection__yuOoJ`,
	"title": `signInForm_title__6q5T0`,
	"zoomInOut": `signInForm_zoomInOut__MfDOa`,
	"subtitle": `signInForm_subtitle__WLAnD`,
	"phoneInputWrapper": `signInForm_phoneInputWrapper__PWtIM`,
	"countryCode": `signInForm_countryCode__M2uqM`,
	"flagIcon": `signInForm_flagIcon__UBus+`,
	"countryCodeText": `signInForm_countryCodeText__WP7zL`,
	"phoneInput": `signInForm_phoneInput__9mg1d`,
	"submitButton": `signInForm_submitButton__Y0Y3+`,
	"arrowIcon": `signInForm_arrowIcon__HN8-w`,
	"termsSection": `signInForm_termsSection__6MhJd`,
	"termsVisible": `signInForm_termsVisible__EjCH0`,
	"termsHidden": `signInForm_termsHidden__drNVq`,
	"termsText": `signInForm_termsText__SnfAy`,
	"termsLink": `signInForm_termsLink__RM+3w`,
	"otpHeader": `signInForm_otpHeader__OkDcm`,
	"backButton": `signInForm_backButton__TQe0-`,
	"backIcon": `signInForm_backIcon__doRBA`,
	"otpTitle": `signInForm_otpTitle__8v76j`,
	"otpInputContainer": `signInForm_otpInputContainer__4BhXh`,
	"otpInputWrapper": `signInForm_otpInputWrapper__b0cKz`,
	"otpInput": `signInForm_otpInput__4ZWeR`,
	"active": `signInForm_active__Wmqaz`,
	"filled": `signInForm_filled__mz2kB`,
	"otpCursor": `signInForm_otpCursor__Nn-Eb`,
	"hideCaret": `signInForm_hideCaret__BxpeB`,
	"otpInfoSection": `signInForm_otpInfoSection__6GwI9`,
	"phoneNumberDisplay": `signInForm_phoneNumberDisplay__+u3HV`,
	"separator": `signInForm_separator__ZNQMY`,
	"resendText": `signInForm_resendText__zOWfg`,
	"resendButton": `signInForm_resendButton__mue-f`,
	"verifyButton": `signInForm_verifyButton__O5m2P`,
	"loadingSpinner": `signInForm_loadingSpinner__3TJd-`,
	"spin": `signInForm_spin__uViWu`,
	"fadeIn": `signInForm_fadeIn__BMWDP`,
	"fadeInTerms": `signInForm_fadeInTerms__cC5kf`,
	"blink": `signInForm_blink__a+Pgt`
};
export default ___CSS_LOADER_EXPORT___;
